import { API_PATH } from 'common/constants/services';
import useQuery from 'hook/useQuery';
import { SETTLEMENTS_STATUS } from 'model/Settlements';
import QueryString from 'qs';
import React, { useEffect, useState } from 'react';

export interface Root {
  coach: Coach;
  current_settlement_profile: CurrentSettlementProfile;
  settled_at: string;
  settlements: Settlement[];
  status: SETTLEMENTS_STATUS;
}

export interface Coach {
  name: string;
}

export interface CurrentSettlementProfile {
  coach_user: number;
  commission: number;
  bank_profile: BankProfile;
}

export interface BankProfile {
  bank_name: string;
  account_number: string;
  owner: string;
}

export interface Settlement {
  net_amount: number;
  raw_amount: number;
  fee_amount: number;
  id: number;
  challenge: Challenge;
}

export interface Challenge {
  id: number;
  name: string;
}

export default function useSettlement(
  userId: number,
  year: number,
  month: number,
) {
  const query = useQuery<Root>(
    `${API_PATH.COACHES_SETTLEMENTS_BATCHES(userId)}${QueryString.stringify(
      { year, month },
      { addQueryPrefix: true },
    )}`,
  );
  return { data: query.getQuery.data?.data };
}
